import React, { useState } from 'react';
import { useResponsive } from '../../../hooks/useResponsive';
import tools from '../../../utils/tools';
import { IOrder } from '../../../types/types';
import Pagination from '../../../layouts/Pagination';

interface OrdersSectionProps {
  orders: IOrder[];
  activeSection: string
}

const OrdersSection: React.FC<OrdersSectionProps> = ({ orders, activeSection }) => {
  const [currentPage, setCurrentPage] = useState(1);
  const ordersPerPage = 20;

  const { isMobile } = useResponsive();

  // Get current orders
  const indexOfLastOrder = currentPage * ordersPerPage;
  const indexOfFirstOrder = indexOfLastOrder - ordersPerPage;
  const currentOrders = orders.slice(indexOfFirstOrder, indexOfLastOrder);

  return (
    <section className={`bottom ${isMobile && activeSection !== 'orders' ? 'hidden-mobile' : ''}`}>
      <h6 className="dashBoardTitle">سفارش ها</h6>

      {isMobile ? (
        <div className="orders-mobile-container">
          {currentOrders.length > 0 ? (
            currentOrders.map((order, index) => (
              <div key={order?.id} className="order-card-mobile">
                <div className="order-card-header">
                  <span className="order-code">
                    <a href={`/order/edit/${order?.id}`}>
                      {order?.code || 'مشاهده'}
                    </a>
                  </span>
                  <span className="order-status">{order?.status}</span>
                </div>
                <div className="order-card-body">
                  <div className="order-detail">
                    <span className="detail-label">تاریخ:</span>
                    <span className="detail-value">{order?.date + ' - ' + order?.fromTime}</span>
                  </div>
                  <div className="order-detail">
                    <span className="detail-label">قیمت:</span>
                    <span className="detail-value price">{tools.formatPrice(order?.finalPrice)}</span>
                  </div>
                  <div className="order-detail">
                    <span className="detail-label">ردیف:</span>
                    <span className="detail-value">{indexOfFirstOrder + index + 1}</span>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div className="no-data-message">
              <p>هیچ سفارشی یافت نشد</p>
            </div>
          )}
        </div>
      ) : (
        <div className="table-responsive">
          <table dir="rtl">
            <thead>
            <tr>
              <th>ردیف</th>
              <th>کد</th>
              <th>تاریخ</th>
              <th>وضعیت</th>
              <th>قیمت</th>
            </tr>
            </thead>
            <tbody>
            {currentOrders.map((order, index) => (
              <tr key={order?.id}>
                <td>{indexOfFirstOrder + index + 1}</td>
                <td>
                  <a href={`/order/edit/${order?.id}`}>
                    {order?.code || 'مشاهده'}
                  </a>
                </td>
                <td>{order?.date + ' - ' + order?.fromTime}</td>
                <td>{order?.status}</td>
                <td>{tools.formatPrice(order?.finalPrice)}</td>
              </tr>
            ))}
            {currentOrders.length === 0 && (
              <tr>
                <td colSpan={5} className="text-center">هیچ سفارشی یافت نشد</td>
              </tr>
            )}
            </tbody>
          </table>
        </div>
      )}

      {orders.length > ordersPerPage && (
        <Pagination
          currentPage={currentPage}
          totalItems={orders.length}
          itemsPerPage={ordersPerPage}
          onPageChange={setCurrentPage}
        />
      )}
    </section>
  );
};

export default OrdersSection;
